import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import { getHighestPriceProgram } from '@utils/program';
import activeProgramShape from '@prospectus/common/types/activeProgramShape';
import { convertCourseRunKeyToCourseKey } from '@utils/courseRecommendations';
import ProgramUpsellWidget from './ProgramUpsellWidget';

function ProgramUpsell({
  intl,
  programs,
  showProgramUpsell,
  courseKey,
}) {
  if (programs.length === 0 || !showProgramUpsell) {
    return null;
  }

  const key = convertCourseRunKeyToCourseKey(courseKey);
  const program = useMemo(() => (
    programs.length === 1 ? programs[0].program : getHighestPriceProgram(programs).program
  ), [programs]);

  return <ProgramUpsellWidget program={program} courseKey={key} intl={intl} />;
}

ProgramUpsell.propTypes = {
  intl: intlShape.isRequired,
  programs: PropTypes.arrayOf(PropTypes.shape(activeProgramShape)),
  showProgramUpsell: PropTypes.bool,
  courseKey: PropTypes.string,
};

ProgramUpsell.defaultProps = {
  programs: [],
  showProgramUpsell: false,
  courseKey: null,
};

export default injectIntl(ProgramUpsell);
